export const formatErrorMessage = (intl, errorMessages, error) =>
  error &&
  intl.formatMessage({
    id: errorMessages[error] ? errorMessages[error].id : error,
    defaultMessage: errorMessages[error]
      ? errorMessages[error].defaultMessage
      : 'An error has occurred. Try again later.',
  });
